import { Select } from '@arco-design/web-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFilters } from '@/context/FilterContext';
import { useMensalidades } from '@/context/MensalidadesContext';

export function CategoryMultiSelect() {
  const { filters, dispatch } = useFilters();
  const { state } = useMensalidades();
  const { t } = useTranslation();

  const options = useMemo(() => {
    const set = new Set<string>();
    for (const tx of state.transactions) if (tx.category) set.add(tx.category);
    return [...set].sort((a, b) => a.localeCompare(b, 'pt-PT'));
  }, [state.transactions]);

  return (
    <div className="aiobi-filter">
      <label className="aiobi-filter__label">{t('filters.categories.label')}</label>
      <Select
        mode="multiple"
        value={filters.categories}
        onChange={(v) => dispatch({ type: 'SET_CATEGORIES', payload: v as string[] })}
        placeholder={t('filters.categories.placeholder')}
        allowClear
        size="small"
        style={{ minWidth: 200, maxWidth: 280 }}
        options={options.map((c) => ({ label: c, value: c }))}
      />
    </div>
  );
}
